import axios from 'axios'
import config from '@/config'

const adminService = {
  getChatGroupList(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: config.BASE_API_URL_V2 + '/inbox/chatgrouplist'
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getChatHistory(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/inbox/chathistory',
        data: {
          memberEmail: data
        }
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  seenChatFlag(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/inbox/seenflag',
        data: {
          memberEmail: data
        }
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getCandidatesList(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: config.BASE_API_URL_V2 + '/inbox/candidatelist'
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getRecruitersList(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: config.BASE_API_URL_V2 + '/inbox/recruiterlist'
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  attachFile(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.BASE_API_URL_V2 + '/inbox/chatattachment', payload.formData, {
          transformRequest: [
            (data, headers) => {
              delete headers.common['Content-Type']
              return data
            }
          ]
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  deleteChatGroup(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/inbox/chatgroupdelete',
        data: {
          memberEmail: data
        }
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  }
}
export default adminService
